import React, { useState, useEffect } from "react";
import { ResellerPageStyle } from "./Reseller.styled";
import TopBar from "../../components/TopBar/TopBar";
import Footer from "../../components/footer/Footer";
import { useDB } from "../../context/DynamoDBContext";
import { getResellerList } from "../../api/ResellerApi";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ViewReseller from "../../components/Modals/ViewReseller";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import EditReseller from "../../components/Modals/EditReseller";
import AddReseller from "../../components/Modals/AddReseller";
import Popup from "../../components/Modals/Modal";
import { ExportDataStyle } from "../../components/Export/ExportData.style";
import { useReload } from "../../context/ReloadContext";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { expiryStatus } from "../../common/ExpiryStatus";
import ROUTE from "../../common/Routes";
import { useNavigate } from "react-router-dom";
import { MainBodyStyle } from "../../styles/MainBodyStyles";

const Reseller = () => {
  const { dynamoDBClient } = useDB();
  const queryClient = useQueryClient();
  const [resellers, setResellers] = useState([]);
  const [resellerListApiEnable, setResellerListApiEnable] = useState(false);
  const [disableIcons, setDisableIcons] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [viewReseller, setViewReseller] = useState("");
  const [reportBtnEnable, setReportBtnEnable] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [deleteID, setDeleteID] = useState("");
  const doc = new jsPDF();
  const { reload } = useReload();
  const [resellerTableStatus, setResellerTableStatus] = useState("Loading ...");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (dynamoDBClient) {
      setResellerListApiEnable(true);
    } else {
      setResellerListApiEnable(false);
    }
  }, [dynamoDBClient]);

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["getResellerList"]);
    }
  }, [reload]);

  const handleError = (type) => {
    if (type === "getResellerList") {
      toast.error("Error while loading Resellers", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const calculateResellers = (
    data = [],
    gatewaysData = [],
    beaconData = [],
    gatewayUser = [],
    devicetoken = [],
    beacons = [],
    android = [],
    ios = []
  ) => {
    const uniqueResellerIds = {};
    const uniqueArray = data.filter((obj) => {
      if (!uniqueResellerIds[obj.ResellerID]) {
        uniqueResellerIds[obj.ResellerID] = true;
        return true;
      }
      return false;
    });

    const result = [];

    uniqueArray.forEach((item) => {
      const gatewayNo = data.filter(
        (item2) =>
          item2.ResellerID === item.ResellerID && item2.GatewayMAC !== ""
      );
      const beaconNo = data.filter(
        (item2) =>
          item2.ResellerID === item.ResellerID && item2.BeaconMAC !== ""
      );

      const activeGatewayNo = gatewayNo.filter((item2) => {
        const count = gatewaysData.filter((item3) => {
          if (item2.GatewayMAC === item3.GatewayMAC) {
            const emailarr = gatewayUser.filter(
              (item4) => item4.GatewayMAC === item3.GatewayMAC
            );

            if (emailarr.length > 0) {
              const foundEmail = emailarr[0].Email;
              const checkOS = devicetoken.filter(
                (item5) => item5.Email === foundEmail
              );

              if (checkOS.length > 0) {
                const foundOS = checkOS[0].MobileDevice;
                if (foundOS === "Android") {
                  const checkAndroidSubscription = android.filter(
                    (item6) => item6.Email === foundEmail
                  );
                  if (checkAndroidSubscription.length > 0) {
                    const checkAndroidExpiry =
                      checkAndroidSubscription[0].SubscriptionState;
                    if (expiryStatus.includes(checkAndroidExpiry)) {
                      // means subscription is expired
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return false;
                  }
                } else {
                  // subscription is ios
                  const checkIosSubscription = ios.filter(
                    (item7) => item7.Email === foundEmail
                  );
                  if (checkIosSubscription.length > 0) {
                    const checkIosExpiry =
                      checkIosSubscription[0].NotificationType;
                    if (expiryStatus.includes(checkIosExpiry)) {
                      // means subscription is expired
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return false;
                  }
                }
              } else {
                return false;
              }
            } else {
              return false;
            }
          }
          return false;
        }).length;

        if (count > 0) {
          return true;
        } else {
          return false;
        }
      }).length;

      const activeBeaconNo = beaconNo.filter((item2) => {
        const count = beaconData.filter((item3) => {
          if (item2.BeaconMAC === item3.BeaconMAC) {
            const emailarr = beacons.filter(
              (item4) => item4.BeaconMAC === item3.BeaconMAC
            );
            if (emailarr.length > 0) {
              const foundEmail = emailarr[0].Email;
              const checkOS = devicetoken.filter(
                (item5) => item5.Email === foundEmail
              );
              if (checkOS.length > 0) {
                const foundOS = checkOS[0].MobileDevice;
                if (foundOS === "Android") {
                  const checkAndroidSubscription = android.filter(
                    (item6) => item6.Email === foundEmail
                  );
                  if (checkAndroidSubscription.length > 0) {
                    const checkAndroidExpiry =
                      checkAndroidSubscription[0].SubscriptionState;
                    if (expiryStatus.includes(checkAndroidExpiry)) {
                      // means subscription is expired
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return false;
                  }
                } else {
                  // ios subscription
                  const checkIosSubscription = ios.filter(
                    (item7) => item7.Email === foundEmail
                  );
                  if (checkIosSubscription.length > 0) {
                    const checkIosExpiry =
                      checkIosSubscription[0].NotificationType;
                    if (expiryStatus.includes(checkIosExpiry)) {
                      // means subscription is expired
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return false;
                  }
                }
              } else {
                return false;
              }
            } else {
              return false;
            }
          }
          return false;
        }).length;

        if (count > 0) {
          return true;
        } else {
          return false;
        }
      }).length;

      result.push({
        ResellerID: item.ResellerID,
        dateCreated: item.DateCreated,
        gateway: gatewayNo.length,
        beacon: beaconNo.length,
        activeGateway: activeGatewayNo,
        activeBeacon: activeBeaconNo,
      });
    });

    const sortedArray = result.sort((a, b) => {
      return new Date(b.dateCreated) - new Date(a.dateCreated);
    });

    setResellers(sortedArray);
  };

  const { data: resellerList, status: recordStatus } = useQuery({
    queryKey: ["getResellerList"],
    queryFn: () => getResellerList(dynamoDBClient),
    enabled: resellerListApiEnable,
    onSuccess: (data) => {
      const resellers = data.resellerTable.Items;
      const gatewaydata = data.gatewayTable.Items;
      const beacondata = data.beaconTable.Items;
      const gatewayUser = data.gatewayUser.Items;
      const devicetoken = data.deviceToken.Items;
      const beacons = data.beacons.Items;
      const android = data.android.Items;
      const ios = data.ios.Items;
      if (resellers.length > 0) {
        calculateResellers(
          resellers,
          gatewaydata,
          beacondata,
          gatewayUser,
          devicetoken,
          beacons,
          android,
          ios
        );
      } else {
        setResellerTableStatus("No Reseller Available");
      }
    },
    onError: (error) => {
      console.log("getResellerList :", error);
      handleError("getResellerList");
    },
  });

  const deleteReseller2 = async (id, reseller) => {
    try {
      const params = {
        TableName: "Resellers",
        Key: {
          Id: id,
          ResellerID: reseller,
        },
      };
      const data = await dynamoDBClient.delete(params).promise();
    } catch (error) {
      setDisableIcons(false);
      throw new Error();
    }
  };

  const deleteReseller = async (reseller) => {
    setDisableIcons(true);

    try {
      const params = {
        TableName: "Resellers",
        FilterExpression: "ResellerID = :id",
        ExpressionAttributeValues: {
          ":id": reseller,
        },
        ProjectionExpression: "Id",
      };
      const data = await dynamoDBClient.scan(params).promise();
      const resellerIdList = data.Items;
      await Promise.all(
        resellerIdList.map((element) => {
          deleteReseller2(element.Id, reseller);
        })
      );

      setDisableIcons(false);
      toast("Reseller Deleted Successfully");
      setResellerListApiEnable(true);
      queryClient.fetchQuery(["getResellerList"]);
    } catch (error) {
      setDisableIcons(false);
      throw new Error();
    }
  };

  const downloadAllReports = async () => {
    setReportBtnEnable(true);
    try {
      const param1 = {
        TableName: "GatewayData",
        ProjectionExpression: "GatewayMAC,DateUpdated",
      };
      const param2 = {
        TableName: "BeaconData",
        ProjectionExpression: "BeaconMAC,DateUpdated",
      };
      const params3 = {
        TableName: "Resellers",
        ProjectionExpression: "BeaconMAC,ResellerID,GatewayMAC",
      };

      const data = await dynamoDBClient.scan(param1).promise();
      const data2 = await dynamoDBClient.scan(param2).promise();
      const data3 = await dynamoDBClient.scan(params3).promise();
      const result1 = data.Items;
      const result2 = data2.Items;
      const result3 = data3.Items;

      const summary = resellers.map((item, index) => [
        ++index,
        item.ResellerID,
        item.gateway,
        item.activeGateway,
        item.beacon,
        item.activeBeacon,
      ]);

      doc
        .text(100, 10, "Ocufii Admin Portal Resellers Report", {
          align: "center",
        })
        .setFontSize(12)
        .setFont("Helvetica", "bold");
      doc.setFontSize(14);
      doc.setFont("Helvetica", "normal");
      doc
        .text(100, 20, `Summary`, { align: "center" })
        .setFontSize(12)
        .setFont("Helvetica", "bold");
      autoTable(doc, {});
      autoTable(doc, {
        head: [
          [
            "#",
            "ResellerID",
            "Base Station",
            "Active Base Station",
            "Beacons",
            "Active Beacons",
          ],
        ],
        body: summary,
      });

      resellers.forEach((element, index) => {
        doc.addPage();
        doc
          .text(100, 20, `ResellerID: ${element.ResellerID}`, {
            align: "center",
          })
          .setFontSize(12)
          .setFont("Helvetica", "bold");

        const bs1 = result3.filter((item) => {
          if (item.ResellerID === element.ResellerID) {
            return item.GatewayMAC;
          }
        });
        let baseStationCount = 1;
        const baseStationResult = bs1.map((item) => {
          const foundGateway = result1.filter(
            (gateway) => gateway.GatewayMAC === item.GatewayMAC
          );
          if (foundGateway.length > 0) {
            return [baseStationCount++, item.GatewayMAC, "Active"];
          } else {
            if (item.GatewayMAC !== "") {
              return [baseStationCount++, item.GatewayMAC, "InActive"];
            }
          }
        });
        autoTable(doc, {});
        autoTable(doc, {
          head: [["#", "GatewayMAC", "Status"]],
          body: baseStationResult,
        });

        const b1 = result3.filter((item) => {
          if (item.ResellerID === element.ResellerID) {
            return item.BeaconMAC;
          }
        });

        let beaconCount = 1;
        const beaconResult = b1.map((item) => {
          const foundBeacon = result2.filter(
            (gateway) => gateway.BeaconMAC === item.BeaconMAC
          );
          if (foundBeacon.length > 0) {
            return [beaconCount++, item.BeaconMAC, "Active"];
          } else {
            if (item.BeaconMAC !== "") {
              return [beaconCount++, item.BeaconMAC, "InActive"];
            }
          }
        });

        autoTable(doc, {});
        autoTable(doc, {
          head: [["#", "BeaconMAC", "Status"]],
          body: beaconResult,
        });
      });

      doc.save("Ocufii All Reseller Report.pdf");

      setReportBtnEnable(false);
    } catch (error) {
      setReportBtnEnable(false);
      toast.error("Error Occured. Try Again", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  return (
    <ResellerPageStyle>
      <Popup
        title="Delete Reseller"
        visible={modal4}
        setVisible={() => setModal4(false)}
        message={
          "This Action will DELETE the Reseller. Are you sure you want to proceed?"
        }
        onAccept={() => {
          setModal4(false);
          deleteReseller(deleteID);
        }}
      />
      <AddReseller
        visible={modal3}
        setVisible={(check) => {
          if (check) {
            setResellerListApiEnable(true);
            queryClient.fetchQuery(["getResellerList"]);
          }
          setModal3(false);
        }}
      />
      <ViewReseller
        visible={modal1}
        setVisible={() => setModal1(false)}
        title={viewReseller}
      />
      <EditReseller
        visible={modal2}
        setVisible={(check) => {
          if (check) {
            setResellerListApiEnable(true);
            queryClient.fetchQuery(["getResellerList"]);
          }
          setModal2(false);
        }}
        id={viewReseller}
      />
      <TopBar authorized={true} />
      <MainBodyStyle>
        {/* Reseller Table */}
        <HeadingStyle>
          Resellers List&ensp;
          <i className="bi bi-clipboard2-data heading-icon" />
        </HeadingStyle>

        <div className="btn-div">
          <button
            className="btn form-button"
            onClick={() => {
              setModal3(true);
            }}
          >
            <i className="bi bi-person-plus-fill add2-icon" />
          </button>
        </div>

        <div className="table-container">
          <div className="table-div">
            <table className="table table-hover">
              <thead className="table-head">
                <tr>
                  <th scope="col" className="table-item">
                    #
                  </th>
                  <th scope="col" className="table-item">
                    ResellerID
                  </th>
                  <th scope="col" className="table-item">
                    Base Station
                  </th>
                  <th scope="col" className="table-item">
                    Active Base Station
                  </th>
                  <th scope="col" className="table-item">
                    Beacons
                  </th>
                  <th scope="col" className="table-item">
                    Active Beacons
                  </th>
                  <th scope="col" className="table-item">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {recordStatus === "loading" || reload ? (
                  <tr>
                    <td colSpan={7}>
                      <p className="table-loading">Loading...</p>
                    </td>
                  </tr>
                ) : resellers.length === 0 ? (
                  <tr>
                    <td colSpan={7}>
                      <p className="table-loading">{resellerTableStatus}</p>
                    </td>
                  </tr>
                ) : (
                  resellers.map((item, index) => {
                    return (
                      <tr key={index}>
                        <th scope="row" className="table-item">
                          {index + 1}
                        </th>
                        <td className="table-item2 table-item">
                          {item.ResellerID}
                        </td>
                        <td className="table-item2 table-item">
                          {item.gateway}
                        </td>
                        <td className="table-item2 table-item">
                          {item.activeGateway}
                        </td>
                        <td className="table-item2 table-item">
                          {item.beacon}
                        </td>
                        <td className="table-item2 table-item">
                          {item.activeBeacon}
                        </td>
                        <td>
                          <div className="action-items">
                            <i
                              title="View"
                              className={
                                disableIcons
                                  ? "bi bi-eye view-icon disable-icon"
                                  : "bi bi-eye view-icon"
                              }
                              onClick={() => {
                                navigate(ROUTE.ViewReseller, {
                                  state: { title: item.ResellerID },
                                });
                                // setViewReseller(item.ResellerID)
                                // setModal1(true)
                              }}
                            />
                            <i
                              title="Update"
                              className={
                                disableIcons
                                  ? "bi bi-pencil edit-icon disable-icon"
                                  : "bi bi-pencil edit-icon"
                              }
                              onClick={() => {
                                setViewReseller(item.ResellerID);
                                setModal2(true);
                              }}
                            />
                            <i
                              title="Delete"
                              className={
                                disableIcons
                                  ? "bi bi-trash delete-icon disable-icon"
                                  : "bi bi-trash delete-icon"
                              }
                              onClick={() => {
                                setDeleteID(item.ResellerID);
                                setModal4(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
        <ExportDataStyle>
          <div title="All Reseller Reports" className="export-div">
            <div
              className={
                reportBtnEnable ? "download-div2 diable-div" : "download-div2"
              }
              onClick={downloadAllReports}
            >
              <i className={"bi bi-cloud-download-fill download-icon2"}></i>
            </div>
          </div>
        </ExportDataStyle>
      </MainBodyStyle>
      <Footer style="footer" />
    </ResellerPageStyle>
  );
};

export default Reseller;
